import { useEffect, useState } from "react";
import "./Style.css";
import { toast } from "react-toastify";
import axiosInstance from "../../../../hooks/axiosInstance";
import axios from "axios";
import {
  Button,
  Form,
  Card,
  Spinner,
  Breadcrumb,
  Row,
  Col,
  Modal,
} from "react-bootstrap";

export default function CreateCustomer({ show, closeModal, refreshPage }) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [toggle, setToggle] = useState(false);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country: "",
    turnover: "",
    state: "",
    city: "",
    area: "",
    status: "",
    // customer_code: "",
    password: "",
  });

  const resetForm = () => {
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      country: "",
      turnover: "",
      state: "",
      city: "",
      area: "",
      status: "",
      customer_code: "",
      password: "",
    });
    setValidationError({});
  };

  // Fetch countries on component mount
  useEffect(() => {
    // Using a static list of common countries
    const commonCountries = [
      "Nigeria",
      "United Kingdom", "United States"
    ];
    setCountries(commonCountries);
  }, []);

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      country: selectedCountry,
      state: "",
      city: "",
    }));
    
    // Fetch states for the selected country
    fetchStates(selectedCountry);
  };

  const fetchStates = async (countryName) => {
    if (!countryName) {
      setStates([]);
      return;
    }
    
    // Static state data for common countries
    const countryStates = {
      "United States": [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", 
        "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", 
        "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", 
        "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", 
        "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", 
        "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", 
        "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", 
        "Wisconsin", "Wyoming"
      ],
      "Canada": [
        "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", 
        "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan"
      ],
      "Australia": [
        "Australian Capital Territory", "New South Wales", "Northern Territory", 
        "Queensland", "South Australia", "Tasmania", "Victoria", "Western Australia"
      ],
      "India": [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", 
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", 
        "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", 
        "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", 
        "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
      ],
      "United Kingdom": [
        "England", "Scotland", "Wales", "Northern Ireland"
      ],
      "Germany": [
        "Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen", "Hamburg", 
        "Hesse", "Lower Saxony", "Mecklenburg-Vorpommern", "North Rhine-Westphalia", 
        "Rhineland-Palatinate", "Saarland", "Saxony", "Saxony-Anhalt", "Schleswig-Holstein", 
        "Thuringia"
      ],
      "France": [
        "Auvergne-Rhône-Alpes", "Bourgogne-Franche-Comté", "Brittany", "Centre-Val de Loire", 
        "Corsica", "Grand Est", "Hauts-de-France", "Île-de-France", "Normandy", 
        "Nouvelle-Aquitaine", "Occitanie", "Pays de la Loire", "Provence-Alpes-Côte d'Azur"
      ],
      "China": [
        "Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong", "Guangxi", 
        "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan", "Hubei", "Hunan", 
        "Inner Mongolia", "Jiangsu", "Jiangxi", "Jilin", "Liaoning", "Ningxia", 
        "Qinghai", "Shaanxi", "Shandong", "Shanghai", "Shanxi", "Sichuan", "Tianjin", 
        "Tibet", "Xinjiang", "Yunnan", "Zhejiang"
      ],
      "Brazil": [
        "Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", 
        "Espírito Santo", "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul", 
        "Minas Gerais", "Pará", "Paraíba", "Paraná", "Pernambuco", "Piauí", 
        "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", "Rondônia", 
        "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"
      ],
      "Mexico": [
        "Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", 
        "Chihuahua", "Coahuila", "Colima", "Durango", "Guanajuato", "Guerrero", "Hidalgo", 
        "Jalisco", "Mexico City", "Michoacán", "Morelos", "Nayarit", "Nuevo León", 
        "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", 
        "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas"
      ],
      "Nigeria": [
        "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", 
        "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "Gombe", "Imo", "Jigawa", 
        "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", 
        "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara",
        "Federal Capital Territory"
      ]
    };
    
    // Set states based on the selected country
    if (countryStates[countryName]) {
      setStates(countryStates[countryName].sort());
    } else {
      setStates([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Submit form data
      await axiosInstance.post("/user/customer/add_customer", formData); // Adjust endpoint as necessary
      handleClose();
      refreshPage(); // Refresh the page or data as needed
      toast.success("Customer created successfully!");
    } catch (error) {
      // Handle validation errors
      if (error.response && error.response.data.data.errors) {
      setValidationError(error.response.data.data.errors.item);
        toast.error("Failed to save user.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  //   const handleClose = () => {
  //     resetForm();
  //     closeModal();
  //   }

  return (
    <div className="CreateCSP">
      <Modal show={show} onHide={handleClose} dialogClassName="modal-lg">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Customer Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formBasicname">
                  <div>
                    <h6>First Name</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                  {validationError.first_name && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.first_name[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formBasicname">
                  <div>
                    <h6>Last Name</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                  {validationError.last_name && (
                    <small classlast_Name="text-danger my-1">
                      {" "}
                      {validationError.last_name[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formEmail">
                  <div>
                    <h6>Email</h6>
                  </div>
                  <Form.Control
                    type="email"
                    placeholder="Enter..."
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {validationError.email && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.email[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formPhone">
                  <div>
                    <h6>Contact</h6>
                  </div>
                  <Form.Control
                    type="number"
                    placeholder="Enter..."
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    
                  />
                  {validationError.phone && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.phone[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formCountry">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    as="select"
                    name="country"
                    value={formData.country}
                    // onChange={handleChange}
                    onChange={handleCountryChange}
                    
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country}
                      </option>
                    ))}
                  </Form.Control>
                  {validationError.country && (
                    <small className="text-danger my-1">
                      {validationError.country[0]}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formState">
                  <div>
                    <h6>State</h6>
                  </div>
                  <Form.Select
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    
                    disabled={!states.length} // Disable state dropdown if no states available
                  >
                    <option value="">Select State</option>
                    {states.map((state, index) => (
                      <option key={index} value={state.name}>
                        {state}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>City</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                  />
                  {validationError.city && (
                    <small className="text-danger my-1">
                      {validationError.city[0]}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>Area</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="area"
                    value={formData.area}
                    onChange={handleChange}
                  />
                  {validationError.area && (
                    <small className="text-danger my-1">
                      {validationError.area[0]}
                    </small>
                  )}
                </Form.Group>
              </Col>
              {/* <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div>
                    <h6>Customer Code</h6>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter..."
                    name="customer_code"
                    value={formData.customer_code}
                    onChange={handleChange}
                  />
                  {validationError.customer_code && (
                    <small className="text-danger my-1">
                      {validationError.customer_code[0]}
                    </small>
                  )}
                </Form.Group>
              </Col> */}
              <Col md={6} lg={6} xs={12} sm={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formPhone">
                  <div>
                    <h6>Turnover</h6>
                  </div>
                  <Form.Control
                    type="number"
                    placeholder="Enter..."
                    name="turnover"
                    value={formData.turnover}
                    onChange={handleChange}
                    
                  />
                  {validationError.turnover && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.turnover[0]}{" "}
                    </small>
                  )}
                </Form.Group>
              </Col>

              {/* <Col md={12} lg={12} xs={12} sm={12} className="mb-2">
                <div className="position-relative auth-pass-inputgroup">
                  <Form.Label>Create Password</Form.Label>
                  <input
                    type={toggle ? `text` : `password`}
                    className="form-control pe-5 password-input"
                    placeholder="Enter password"
                    aria-describedby="passwordInput"
                    onChange={handleChange}
                    value={formData.password}
                    name="password"
                    
                  />
                  {validationError.password && (
                    <small className="text-danger my-1">
                      {" "}
                      {validationError.password[0]}{" "}
                    </small>
                  )}
                  <button
                    className="btn btn-link position-absolute end-0 text-decoration-none text-muted password-addon"
                    style={{ top: "30px" }}
                    type="button"
                    onClick={handleToggle}
                  >
                    <i
                      className={`${
                        toggle ? "ri-eye-off-fill" : "ri-eye-fill"
                      } align-middle`}
                    ></i>
                  </button>
                  <div className="invalid-feedback">Please enter password</div>
                </div>
              </Col> */}

            </Row>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="link" onClick={handleClose}>
              Close
            </Button> */}
            <Button
              className=""
              style={{
                backgroundColor: "#c4281b",
                color: "#fff",
                border: "none",
              }}
              type="submit"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* <ToastContainer /> */}
    </div>
  );
}
